import Dropzone from './Dropzone'
import Faq from './Faq'

function App() {

  return (
    <div className="App">
      <header>
        <h1>Video as image</h1>
        <p>画像を放り込むと、ほぼ1フレームの動画に変換できます。</p>
        <p>画像はアップロードされず、お使いのブラウザ上で変換処理が行われます。その為、処理にかかる時間はお使いのPCの性能によります。恐らく、長くても数分だと思います。</p>
      </header>
      <Dropzone />
      <Faq />
    </div>
  );
}

export default App
